import { Component, OnDestroy, OnInit, AfterViewInit } from '@angular/core';
import { ContentfulService } from 'src/app/shared/services/contentful.service';
import { Subscription } from 'rxjs';
import { CountrycurrencypageService } from '../countrycurrencypage.service';
import { HubspotCustomFormService } from 'src/app/shared/services/hubspot-custom-form.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-country-currency-subscribe-form',
  templateUrl: './country-currency-subscribe-form.component.html',
  styleUrls: ['./country-currency-subscribe-form.component.scss'],
  imports: [CommonModule],
})
export class CountryCurrencySubscribeFormComponent
  implements OnInit, OnDestroy, AfterViewInit
{
  constructor(
    private contentful: ContentfulService,
    private customFormService: HubspotCustomFormService,
    private countryCurrencyPageService: CountrycurrencypageService
  ) {
    this.subscriptions = [];
  }

  ngOnDestroy(): void {
    if (this.subscriptions && this.subscriptions.length > 0) {
      this.subscriptions.forEach(subscription => {
        subscription.unsubscribe();
      });
    }
  }

  subscriptions: Subscription[];
  formData: any;

  ngOnInit(): void {
    this.countryCurrencyPageService.form$.subscribe(data => {
      if (data != null) {
        this.formData = {
          header: data.title,
          paragraph: data.content,
          placeholder:
            data.component1[0].fields?.description?.content[0].content[0]
              .value ?? '',
          buttontext: data.component1[0].fields?.button[0].fields.buttonText,
        };
      }
    });
  }
  ngAfterViewInit() {
    const pathSegments = window.location.pathname.replace(/^\/|\/$/g, '').split('/');
    const coveragePageName = pathSegments[pathSegments.length - 1] || 'coverage';
    this.customFormService.generateCustomForm('bg-dark', coveragePageName);
  }
}
